/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:04:49
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/line.js
 */
export default {
    // line组件
    line: {
        color: '#d6d7d9',
        length: '100%',
        direction: 'row',
        hairline: true,
        margin: 0,
        dashed: false
    }
}
